import React, { FC } from 'react';
import { faqHeaderBgImage } from 'assets/images/faq';
import { RetailTextBlock } from 'components/retail/structures';
import { HeaderBgImage } from 'containers/common/sections/faq/index';
import useI18n from "evcharging/hooks/useI18n";

const HeaderSectionFAQ: FC = () => {
  const { t } = useI18n();

  const listItems = [
    {
      title: t('faq.popular-questions'),
      text: t('faq.popular-questions.description'),
    },
    {
      title: t('faq.general-info'),
      text: t('faq.general-info.description'),
    },
  ];

  return (
    <>
      <HeaderBgImage
        backgroundSrc={faqHeaderBgImage}
        title={t('faq.title')}
        text={t('faq.description')}
      />
      {/*<RetailTextBlock list={listItems} />*/}
    </>
  );
};

export default HeaderSectionFAQ;
